import {get, post} from '../../utils/ApiUtil';
import Admin from '../../models/Admin';

/**
 * ログイン
 *
 * @param email
 * @param password
 * @param remember
 * @returns {Promise<Admin>}
 */
export async function loginAdmin(email, password, remember) {
  const data = await post('/api/admin/auth/login', {email, password, remember});
  return new Admin(data);
}

/**
 * ログアウト
 *
 * @returns {Promise<void>}
 */
export async function logoutAdmin() {
  await post('/api/admin/auth/logout');
}

/**
 * ログイン中の管理者を取得
 *
 * @returns {Promise<Admin>}
 */
export async function getCurrentAdmin() {
  const data = await get('/api/admin/me');
  return new Admin(data);
}

/**
 * パスワードのリセットリクエストを送信
 *
 * @param email
 * @returns {Promise<void>}
 */
export async function forgotPassword(email) {
  await post('/api/admin/auth/forgot_password', {email});
}

/**
 * パスワードを更新
 *
 * @param email
 * @returns {Promise<void>}
 */
export async function resetPassword(email) {
  await post('/api/admin/auth/reset_password', email);
}

/**
 * Change password
 *
 * @param currentPassword
 * @param password
 * @param passwordConfirmation
 * @returns {Promise<Object>}
 */
export async function changePassword(currentPassword, password, passwordConfirmation) {
  return await post('/api/admin/auth/change_password', {
    current_password: currentPassword,
    password: password,
    password_confirmation: passwordConfirmation
  });
}
